export class Inputs {
    constructor(input, parentSelector = '.gfield') {
        const i = input;
        const parent = this.getClosest(input, parentSelector);
        if (i.value == '') {
            parent.classList.remove('has-value');
            parent.classList.remove('is-focused');
        }
        else {
            parent.classList.remove('is-focused');
            parent.classList.add('has-value');
        }
        input.addEventListener('focus', () => {
            parent.classList.add('is-focused');
        });
        input.addEventListener('blur', () => {
            if (i.value == '') {
                parent.classList.remove('has-value');
                parent.classList.remove('is-focused');
            }
            else {
                parent.classList.remove('is-focused');
                parent.classList.add('has-value');
            }
        });
    }
    getClosest(elem, selector) {
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector))
                return elem;
        }
        return null;
    }
}
